(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["assistco-b2b-notice"] && !Shopify.designMode) return;
  try {
    (() => {
    const showNotice = () => {
      const dialog = document.getElementById('AssistcoB2BNotice');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const key = 'assistco-ordering-20261020-v1-' + dialog.dataset.customer;
      try { if (sessionStorage.getItem(key) === 'seen') return; } catch (error) {}
      dialog.showModal();
      try { sessionStorage.setItem(key, 'seen'); } catch (error) {}
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', showNotice, { once: true });
    } else {
      showNotice();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
